<div
    [attr.data-testId]="id"
    [attr.data-styleId]="id"
    [attr.data-uitype]="'builder-component'"
    [id]="id"
>
    @switch (component()?.type) {
    @case('ErrorScreen') {
    <div class="flex flex-col items-center text-center pt-4">
        <mat-icon
            class="!h-[29px] !w-[32px]"
            svgIcon="app:empty_box"
        ></mat-icon>
        <span class="text-dat-grey-500 font-caption-strong">{{
            props()?.message ?? '--'
        }}</span>
    </div>
    } @case('ErrorScreenLarge') {
    <div class="flex flex-col items-center text-center">
        <mat-icon
            class="!h-[64px] !w-[64px]"
            svgIcon="app:empty_box"
        ></mat-icon>
        <span class="text-dat-grey-500 font-body-large-strong">{{
            props()?.message ?? '--'
        }}</span>
    </div>
    } @case ('McGaugeQueryLt') {
    <iq-mc-gauge-query-lt 
        [id]="props().id"
        [clickable]="props().clickable ?? true"
    ></iq-mc-gauge-query-lt>
    } @case ('RecentSearchesLanes') {
    <iq-table-rate-recent-search
        [id]="props()?.id"
        [searches]="props()?.searches"
    ></iq-table-rate-recent-search>
    } @case ('McGaugeQueryMci') {
    <iq-mc-gauge-query-mci [id]="props().id"></iq-mc-gauge-query-mci>

    }@case ('McGaugeMci') {
    <iq-mc-gauge-mci
        [dashboardId]="props().dashboardId"
        [id]="props().id"
    ></iq-mc-gauge-mci>
    }@case ('McGaugeSection') {
    <iq-mc-gauge-section
        [dashboardId]="props().dashboardId"
        [id]="props().id"
        [mciGaugeId]="props().mciGaugeId"
        [ltGaugeId]="props().ltGaugeId"
    ></iq-mc-gauge-section>
    }@case('MCSingleLaneMap') {

    <iq-mc-map-lane-map [id]="props()?.id"></iq-mc-map-lane-map>

    } @case('MCLoads') {
    <iq-graph-lt-loads [id]="props().id"></iq-graph-lt-loads>
    } @case('MCTrucks') {
    <iq-graph-lt-trucks [id]="props().id"></iq-graph-lt-trucks>
    } @case('TableRate13MHistorical') {
    <iq-table-rate-historical-13m
        [id]="props().id"
    ></iq-table-rate-historical-13m>
    } @case('TableRate13MForecast') {
    <iq-table-rate-forecast-13m [id]="props().id"></iq-table-rate-forecast-13m>
    } @case('TableRate35DForecast') {
    <iq-table-rate-forecast-35d [id]="props().id"></iq-table-rate-forecast-35d>
    } @case('GraphRate13MForecast') {
    <iq-graph-rates-thirteen-month-forecast
        [id]="id"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
        [equipmentType]="props()?.equipmentType"
        [contractType]="props()?.contractType"
        [perMile]="props()?.perMile"
        [quote]="props()?.quote"
        [vizTime]="props()?.vizTime"
    ></iq-graph-rates-thirteen-month-forecast>
    } @case('GraphRate13MHistorical') {
    <iq-graph-rates-thirteen-month-historical
        [dashboardId]="props().dashboardId"
        [id]="id"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
        [equipmentType]="props()?.equipmentType"
        [contractType]="props()?.contractType"
        [perMile]="props()?.perMile"
        [quote]="props()?.quote"
        [vizTime]="props()?.vizTime"
    ></iq-graph-rates-thirteen-month-historical>
    } @case('GraphRate35DForecast') {
    <iq-graph-rates-thirty-five-day-forecast
        [equipmentType]="props()?.equipmentType"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
        [perMile]="props()?.perMile"
        [quote]="props()?.quote"
        [vizTime]="props()?.vizTime"
    >
    </iq-graph-rates-thirty-five-day-forecast>
    } @case('GraphRateHybrid') {
    <iq-graph-rates-hybrid [id]="props()?.id" [vizTime]="props()?.vizTime">
    </iq-graph-rates-hybrid>
    } @case('TableContributions') {
    <iq-table-contributions-table [id]="id"></iq-table-contributions-table>
    } @case ('NtlGraphRateMulti') {
    <iq-ntl-graph-rates-multi
        [id]="props()?.id"
    ></iq-ntl-graph-rates-multi>
    } @case ('StateRegionMatrix') {
    <iq-state-region-matrix-card
        [id]="props()?.id"
    ></iq-state-region-matrix-card>
    } @case ('Label') {
    <iq-builder-label
        [id]="id"
        [label]="props()?.label"
        [type]="props()?.type?.length ? props()?.type : 'md'"
        [tooltipBody]="props()?.tooltipBody"
        [flag]="props()?.flag"
        [flagLabel]="props()?.flagLabel"
        [tooltipHeader]="props()?.tooltipHeader"
    ></iq-builder-label>
    } @case ('Controls') {
    <iq-controls-dashboard
        [dashboardId]="dashboardId"
        [id]="props()?.id"
        [controls]="props()?.controls"
        [containerClasses]="props()?.containerClasses"
        [cssClassRules]="props()?.cssClassRules"
    ></iq-controls-dashboard>
    } @case ('CardRateNational') {
    <iq-rate-ntl-card
        [id]="props()?.id"
        [rateType]="props()?.rateType"
    ></iq-rate-ntl-card>
    } @case('TrendlinesNtlSpotFlatbed') {
    <iq-trendlines-ntl-spot-flatbed [id]="id"> </iq-trendlines-ntl-spot-flatbed>
    } @case('TrendlinesNtlSpotVan') {
    <iq-trendlines-ntl-spot-van [id]="id"> </iq-trendlines-ntl-spot-van>
    } @case('TrendlinesNtlSpotReefer') {
    <iq-trendlines-ntl-spot-reefer [id]="id"> </iq-trendlines-ntl-spot-reefer>
    } @case('TrendLineSnapshotTable') {
    <iq-trendlines-snapshot-table
        [id]="id"
        [testId]="id"
    ></iq-trendlines-snapshot-table>
    } @case('TrendLinesFfRegister') {
        <iq-trendlines-ff-register
            [id]="id"
            [testId]="id"
        ></iq-trendlines-ff-register>
    } @case('TrendlineWeeklyBrief') {
    <iq-trendlines-social-weekly-brief
        [id]="id"
        [testId]="id"
    ></iq-trendlines-social-weekly-brief>
    } @case('TrendlineFuelPrices') {
    <iq-trendlines-fuel-card [id]="id" [testId]="id"></iq-trendlines-fuel-card>
    } @case('TrendlinesRatesGraphReefer') {
    <iq-trendlines-graph-rates-reefer
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-reefer>
    } @case('TrendlinesRatesGraphFlatbed') {
    <iq-trendlines-graph-rates-flatbed
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-flatbed>
    } @case('TrendlinesRatesGraphVan') {
    <iq-trendlines-graph-rates-van
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-van>
    } @case('TrendlinesRatesNationalGraphVan') {
    <iq-trendlines-graph-rates-ntl-van
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-ntl-van>
    } @case('TrendlinesRatesNationalGraphReefer') {
    <iq-trendlines-graph-rates-ntl-reefer
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-ntl-reefer>
    } @case('TrendlinesRatesNationalGraphFlatbed') {
    <iq-trendlines-graph-rates-ntl-flatbed
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-rates-ntl-flatbed>
    } @case('TrendlinesLtNationalGraphReefer') {
    <iq-trendlines-graph-lt-ntl-reefer
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-ntl-reefer>
    } @case('TrendlinesLtNationalGraphFlatbed') {
    <iq-trendlines-graph-lt-ntl-flatbed
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-ntl-flatbed>
    } @case('TrendlinesLtNationalGraphVan') {
    <iq-trendlines-graph-lt-ntl-van
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-ntl-van>
    } @case('TrendlinesLtGraphReefer') {
    <iq-trendlines-graph-lt-reefer
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-reefer>
    } @case('TrendlinesLtGraphFlatbed') {
    <iq-trendlines-graph-lt-flatbed
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-flatbed>
    } @case('TrendlinesLtGraphVan') {
    <iq-trendlines-graph-lt-van
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-graph-lt-van>
    } @case('TrendlinesLtMapReefer') {
    <iq-trendlines-map-lt-reefer
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-map-lt-reefer>
    } @case('TrendlinesLtMapFlatbed') {
    <iq-trendlines-map-lt-flatbed
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-map-lt-flatbed>
    } @case('TrendlinesLtMapVan') {
    <iq-trendlines-map-lt-van
        [id]="props()?.id"
        [testId]="props()?.testId"
    ></iq-trendlines-map-lt-van>
    } @case('SocialBlog') {
    <iq-links-blog-links
        [id]="component()?.props?.id"
        [articlesLimit]="component()?.props?.articlesLimit"
    ></iq-links-blog-links>
    } @case('SocialPodcast') {
    <iq-social-links-podcast
        [id]="component()?.props?.id"
    ></iq-social-links-podcast>
    } @case('SocialHelpCenter') {
    <iq-social-links-help-center
        [id]="component()?.props?.id"
    ></iq-social-links-help-center>
    } @case('TrendlinesRatesMapReefer') {
    <iq-trendlines-map-rate-reefer
        [id]="component()?.props?.id"
        [testId]="component()?.props?.testId"
    ></iq-trendlines-map-rate-reefer>
    } @case('TrendlinesRatesMapFlatbed') {
    <iq-trendlines-map-rate-flatbed
        [id]="component()?.props?.id"
        [testId]="component()?.props?.testId"
    ></iq-trendlines-map-rate-flatbed>
    } @case('TrendlinesRatesMapVan') {
    <iq-trendlines-map-rate-van
        [id]="component()?.props?.id"
        [testId]="component()?.props?.testId"
    ></iq-trendlines-map-rate-van>
    } @case('SocialVideo') {
    <iq-media-video
        [id]="component()?.props.id"
        [videoId]="component()?.props?.videoId"
    ></iq-media-video>
    } @case('McMapMciDashboard') {
    <iq-mc-map-mci-dashboard [id]="props()?.id"></iq-mc-map-mci-dashboard>
    } @case('McModalMci') {
        <iq-mc-modal-mci [id]="props()?.id"></iq-mc-modal-mci>
        } @case('RateLaneODSearchFormatter') {
    <iq-rate-lane-utils-od-search-formatter
        [id]="props()?.id"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
        [equipmentType]="props()?.equipmentType"
        [dashboardId]="props()?.dashboardId"
        [sectionId]="props()?.sectionId"
        [componentId]="props()?.componentId"
        [originControlId]="props()?.originControlId"
        [destinationControlId]="props()?.destinationControlId"
        [equipmentControlId]="props()?.equipmentControlId"
    ></iq-rate-lane-utils-od-search-formatter>
    } @case('RateLaneFuelLoader') {
    <iq-rate-lane-utils-fuel-loader
        [equipmentType]="props()?.equipmentType"
        [dashboardId]="props()?.dashboardId"
        [quote]="props()?.quote"
        [mileage]="props()?.mileage"
    >
    </iq-rate-lane-utils-fuel-loader>
    } @case('RateLaneMileageLoader') {
    <iq-rate-lane-utils-mileage-loader
        [dashboardId]="props()?.dashboardId"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
    ></iq-rate-lane-utils-mileage-loader>
    } @case('RateLaneRateLoader') {
    <iq-rate-lane-utils-rate-loader
        [dashboardId]="props()?.dashboardId"
        [origin]="props()?.origin"
        [destination]="props()?.destination"
        [rateType]="props()?.rateType"
        [equipmentType]="props()?.equipmentType"
    ></iq-rate-lane-utils-rate-loader>
    } @case('TrendlinesContentViewTrends') {
    <iq-trendlines-content-view-trends></iq-trendlines-content-view-trends>

    } @case ('RepoLibraryStatusCard'){
    <iq-status-library-card
        [id]="component()?.id"
        [projectKey]="props()?.projectKey"
    ></iq-status-library-card>
    } @case ('RepoLibraryStatusViz'){
    <iq-status-library-visualization
        [id]="component()?.id"
        [query]="props()?.query"
    ></iq-status-library-visualization>
    }@case ('RepoLibraryStatusCardGrid'){
    <iq-status-library-card-grid
        [id]="component()?.id"
        [query]="props()?.query"
    ></iq-status-library-card-grid>
    } @case ('RepoLibraryStatusTable'){
    <iq-status-library-table
        [id]="component()?.id"
        [query]="props()?.query"
    ></iq-status-library-table>
    } @case ('RateLaneEventBusRegister') {
    <iq-rate-lane-event-bus-register></iq-rate-lane-event-bus-register>
    } @case ('McEventBusRegister') {
    <iq-mc-event-bus-register></iq-mc-event-bus-register>
    } @case('GraphRatesTime') {
    <iq-graph-rates-time [id]="props()?.id"></iq-graph-rates-time>
    } @case('GraphRatesAll') {
    <iq-graph-rates-all [id]="props()?.id"></iq-graph-rates-all>
    } @case ('McLtChart') {
    <iq-mc-charts-lt [id]="props()?.id"></iq-mc-charts-lt>
    } @case ('McMciChart'){
    <iq-mc-charts-mci-prior [id]="props()?.id"></iq-mc-charts-mci-prior>
    } @case('RatesTable'){
    <iq-table-rate-shared [id]="props()?.id"></iq-table-rate-shared>
    } @case('McMapLt'){
    <iq-mc-map-lt [id]="props()?.id"></iq-mc-map-lt>
    } @case('McMapMci') {
    <iq-mc-map-mci [id]="props()?.id"></iq-mc-map-mci>
    }
    @case ('McCapacityLabel') {
        <iq-mc-label-capacity [id]="props().id"></iq-mc-label-capacity>
    }
    @case('TrendlinesUpsellBanner'){
    <iq-trendlines-upsell-banner [id]="props()?.id" [type]="props().type" [equipmentType]="props().equipmentType"></iq-trendlines-upsell-banner>
    }
    @default {
    {{ id }}
    } }
</div>
